import { Capacitor } from '@capacitor/core';
import { getApp, getApps, initializeApp } from 'firebase/app';
import {
	browserPopupRedirectResolver,
	indexedDBLocalPersistence,
	initializeAuth,
} from 'firebase/auth';

import { environment } from '../environments/environment';

export const initFirebaseApp = async () => {
	const app =
		getApps().length > 0 ? getApp() : initializeApp(environment.firebaseConfig);
	if (Capacitor.isNativePlatform()) {
		initializeAuth(app, {
			persistence: indexedDBLocalPersistence,
		});
	} else {
		initializeAuth(app, {
			persistence: indexedDBLocalPersistence,
			popupRedirectResolver: browserPopupRedirectResolver,
		});
	}
};
